import { UpsertCustomFormFieldsRequest } from '@/apiClient';
import { usePrivate } from '@/components/private';
import useSWRMutation from 'swr/mutation';

export const getUpsertCustomFormFieldsCacheKey = () => {
  return '/api/CustomForm/UpsertCustomFormFields';
};

type TUpdateFormOptions = {
  shouldFetch: boolean;
};

export const useUpdateCustomForm = (
  request: UpsertCustomFormFieldsRequest,
  options: TUpdateFormOptions = { shouldFetch: true },
) => {
  const { customFormApi } = usePrivate();

  const reults = useSWRMutation(
    customFormApi && options?.shouldFetch
      ? getUpsertCustomFormFieldsCacheKey
      : null,
    () => customFormApi?.apiCustomFormUpsertCustomFormFieldsPost(request),
    {
      onError(error) {
        console.log(
          '[BREEDLOGIC] <useUpdateCustomForm> error update custom form.',
          error,
        );
      },
    },
  );

  return { ...reults };
};
